import * as Constant from '../Constants/Constant';

export default {
    setGen1Order(gen1Order) {
        this.Dispatch({
            type: Constant.GEN1_ACT_SET_ORDER,
            gen1Order,
        });
    },
};
